// extracted by mini-css-extract-plugin
export default {"container":"avatar_container__3upTf","shape":"avatar_shape__2MSKc"};